import { MainRequest } from "./index";

type SettingValue = "0" | "1";

export interface SettingsData {
    sign: SettingValue;
    vote: SettingValue;
    exercise: SettingValue;
    homework: SettingValue;
    exam: SettingValue;
    chat: SettingValue;
    evaluation: SettingValue;
    groupActivity: SettingValue;
    answeringGroup?: SettingValue;
    discussGroup?: SettingValue;
    discuss?: {
        newDiscuss: SettingValue;
        floorNewUpdate: SettingValue;
        replyNewUpdate: SettingValue;
    };
    answering?: {
        newFloor: SettingValue;
        floorNewUpdate: SettingValue;
        floorNewReply: SettingValue;
        replyNewUpdate: SettingValue;
    };
}

/**
 * 查询通知设置
 */
export async function getNoticeSet(): Promise<SettingsData> {
    const res = await MainRequest.get<SuccessData<{ content: SettingsData }>>(
        "/student/busiNotice/getNoticeSet"
    );

    const data = res.data.data.content;

    const answeringGroup: SettingValue = Object.values(
        data.answering || {}
    ).includes("1")
        ? "1"
        : "0";

    const discussGroup: SettingValue = Object.values(
        data.discuss || {}
    ).includes("1")
        ? "1"
        : "0";

    return { ...data, answeringGroup, discussGroup };
}

/**
 * 保存通知设置
 * @param data
 */
export function saveNoticeSet(data: SettingsData) {
    const { answeringGroup, discussGroup, ...content } = data;

    return MainRequest.post(
        "/student/busiNotice/saveNoticeSet",
        {
            content
        },
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    );
}
